import { render, staticRenderFns } from "./ApprovalList.vue?vue&type=template&id=7ac86e0a"
import script from "./ApprovalList.vue?vue&type=script&lang=js"
export * from "./ApprovalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports